import elementDescriptionService from "@/pages/ProcessModeling/Menu/ElementDescriptionSection/element-description-service";
import elementNumberService from "@/components/elementNumberService.js"
import { jsPDF } from "jspdf";
import 'jspdf-autotable'
import store from '@/store';
import { getContrastColor } from "@/components/colorContrast"
import userService from "@/components/userService.js"
import processlistService from "@/pages/ProcessList/processlist-service";
import documentService from "@/pages/ProcessModeling/Menu/DocumentSection/document-service.js"
import mngmtLinkService from "@/pages/ProcessModeling/Menu/MngmtLinkSection/mngmtLink-service.js"
function decodeModuleNameByNumber(moduleNumber) {
    switch (moduleNumber) {
        case 1:
            return "Bindungsmodul";
        case 2:
            return "Job-Fit-Modul";
        case 3:
            return "Steuerungsmodul";
        case 4:
            return "Prozessperspektiven-Modul";
        case 5:
            return "Belastungsmodul";
    }
}

function decodeModuleNameByNumberForEvaluation(moduleNumber) {
    switch (moduleNumber) {
        case 1.1:
            return "Stimmungsbild der Beschäftigten"
        case 1:
            return "Stressoren und Ressourcen";
        case 2:
            return "Job-Fit-Modul";
        case 3:
            return "Steuerungsmodul";
        case 4:
            return "Prozessperspektiven-Modul";
        case 5:
            return "Psychische Belastung";
    }
}

function decodeModuleNameByEnum(enumVal) {
    switch (enumVal) {
        case "Module_One":
            return "Bindungsmodul";
        case "Module_Two":
            return "Job-Fit-Modul";
        case "Module_Three":
            return "Steuerungsmodul";
        case "Module_Four":
            return "Prozessperspektiven-Modul";
        case "NONE":
            return "Benutzerdefiniert";
        case "STRESS_MODULE":
            return "Belastungsmodul"
    }
}

function decodeElementByName(val) {
    switch (val) {
        case "Process":
            return "Prozess";
        case "Activity":
            return "Aktivität";
        case "Gateway":
            return "Entscheidung";
        case "Event":
            return "Ereignis";
        case "Flow":
            return "Kommunikation";
        case "Lane":
            return "Rolle";
        case "Pool":
            return "Prozess";
        case "DataStore":
            return "System";
        case "DataObject":
            return "Dokument";
    }
}

function getChecklistStepDescription(val) {
    switch (val) {
        case 1:
            return "1. Phase: Alle Beschäftigten im Betrieb verstehen den Zweck, der mit der Einführung der digitalen Technologie erreicht werden soll.";
        case 2:
            return "2. Phase: Die Einführung der digitalen Technologie wird in konkreten Schritten geplant und der Plan an die Belegschaft kommuniziert. ";
        case 3:
            return "3. Phase: Es wird überprüft, ob die durchgeführten Anpassungen erfolgreich sind oder ob noch weiterer Anpassungsbedarf nach dem Beginn der Einführung der digitalen Technologie besteht.";
        case 4:
            return "4. Phase: Es wird entschieden, ob die digitale Technologie auch in anderen Bereichen des Unternehmens einsetzbar ist. Falls dies der Fall sein sollte, werden die Erkenntnisse der vorherigen Schritte „Zweck bestimmen“, „Gezielt vorbereiten“ und „Weiter anpassen“ genutzt und die unternehmensweite Verbreitung geplant und umgesetzt.";
        case 5:
            return "5. Phase: Die Nutzung der neuen Technologie soll zur Routine werden. "
    }
}

function decodeQuestionType(val) {
    switch (val) {
        case "MATRIX":
            return "Matrix";
        case "DATEPICKER":
            return "Datumsauswahl";
        case "TEXT":
            return "Text";
        case "RATING":
            return "Rating";
        case "COMMENT":
            return "Kommentar";
        case "RADIOGROUP":
            return "Radiobutton";
    }
}

function decodeSurveyState(state) {
    switch (state) {
        case "ANSWERED":
            return "Beantwortet";
        case "SEND":
            return "Versendet";
        case "FINISHED":
            return "Beendet";
        case "CREATED":
            return "Erstellt";
    }
}

function getSurveyStateDescription(state) {
    switch (state) {
        case "ANSWERED":
            return "Die Umfrage wurde von einigen Teilnehmern beantwortet. Es stehen noch Antworten aus.";
        case "SEND":
            return "Die Umfrage wurde versendet aber noch nicht beantwortet";
        case "FINISHED":
            return "Die Umfrage wurde von allen Teilnehmern beantwortet";
        case "CREATED":
            return "Die Umfrage wurde erstellt aber noch nicht versendet";
    }
}

function parseSurveyStateColor(state) {
    switch (state) {
        case "ANSWERED":
            return "violet";
        case "SEND":
            return "lightblue";
        case "FINISHED":
            return "lightgreen";
        case "CREATED":
            return "gray";
    }
}

function decodePermissionName(perm) {
    switch (perm) {
        case "PROCESS_READ":
            return "Prozess anzeigen";
        case "PROCESS_WRITE":
            return "Prozess bearbeiten";
        case "PX_WRITE":
            return "Umfragen erstellen";
        case "PX_EVAL":
            return "Umfragen auswerten";
        case "ADMIN":
            return "Admin";
        case "SUPER_ADMIN":
            return "Superuser";
        case "TRAINER":
            return "Trainer";
        case "EDIT_CONTEXTITEM":
            return "Prozessobjekte bearbeiten";
        case "SURVEY":
            return "Zugriff Bereich Process Experience";
        case "PROCESS":
            return "Zugriff Prozessbereich";
    }
}

function getPermissionDescription(perm) {
    switch (perm) {
        case "PROCESS_READ":
            return "Die Rolle kann Prozessmodelle anzeigen und Kommentare verfassen";
        case "PROCESS_WRITE":
            return "Die Rolle kann Prozessmodelle bearbeiten";
        case "PX_READ":
            return "Die Rolle kann in den ProcessExperience-Modus wechseln";
        case "PX_WRITE":
            return "Die Rolle kann Fragen an Elemente anheften und Umfragen erstellen";
        case "PX_EVAL":
            return "Die Rolle kann prozessbasierte Umfragen auswerten";
        case "ADMIN":
            return "Der Admin erhält alle anderen Berechtigungen";
        case "SUPER_ADMIN":
            return "Der Superuser kann alles was der Admin kann und zusätzlich Mandanten erstellen und bearbeiten";
        case "TRAINER":
            return "Die Trainer Rolle wurde für Workshops oder Schulungen geschaffen. Ein Trainer kann alle Prozessmodelle in einem Mandanten einsehen, ohne dass diese Explizit freigegeben werden müssen";
        case "EDIT_CONTEXTITEM":
            return "Die Rolle kann Prozessobjekte (IT-Systeme etc.) hinzufügen und bearbeiten. Wird dieses Recht nicht vergeben kann die Rolle die Prozessobjekte nur Nutzen aber nicht administrieren.";
        case "SURVEY":
            return "Dieses Recht regelt den Zugriff auf den Bereich Process Experience. Wird dieses Recht nicht vergeben kann der Nutzer nicht in diesen Bereich navigieren und weder Fragen erstellen noch Umfragen erstellen und auswerten. Die Teilnahme an Umfragen ist davon nicht betroffen.";
        case "PROCESS":
            return "Dieses Recht regelt den Zugriff auf den Bereich Prozesse. Wird dieses Recht nicht vergeben kann der Nutzer den Bereich Prozesse nicht einsehen und weder Prozesse erstellen, noch diese bearbeiten.";
    }
}

function decodeCharacteristicFieldToName(field) {
    return readableNames[field] ? readableNames[field] : "";
}
async function generateReportStructure(reportData, uuid, filename, modelInformation) {
    let userName = await userService.retrieveUser(modelInformation.initiator)
    let modelInfo = {
        createdDate: new Date(modelInformation.creationDate),
        initiator: userName.data ? userName.data.fullName : modelInformation.initiator,
        lastModifiedDate: new Date(modelInformation.lastModifiedDate),
        docNr: modelInformation.docNr,
        mngmtLink: modelInformation.mngmtLink,
        lastEditor: '',
        processId: uuid
    }

    let reportElements = { svgData: '', elements: [] };

    reportData.elements.forEach(elem => {
        let elementToReport = {};
        if (elem.id.toUpperCase().includes("ACTIVITY") && !elem.type.toUpperCase().includes("LABEL") && !elem.businessObject.extensionElements) {
            elementToReport.id = elem.id;
            if (elem.businessObject != null) {
                elementToReport.text = elem.businessObject.name;
            }
            elementToReport.role = getLaneId(elem, reportData.elements);
            reportElements.elements.push(elementToReport);
        }
    });

    let descriptionData = await elementDescriptionService.retrieveElementsWithDescription(uuid);
    reportElements.elements = reportElements.elements.map(item => ({
        ...item,
        description: descriptionData.data.find(d => d.elementId == item.id)
            ? descriptionData.data.find(d => d.elementId == item.id).text
            : ''
    }));

    let mngmtLinkData = await mngmtLinkService.retrieveElementsWithLinks(uuid);
    reportElements.elements = reportElements.elements.map(item => ({
        ...item,
        mngmtLink: mngmtLinkData.data.find(d => d.elementId == item.id)
            ? mngmtLinkData.data.find(d => d.elementId == item.id).text
            : ''
    }));

    let elemNumData = await elementNumberService.retrieveElementsWithNumber(uuid);
    reportElements.elements = reportElements.elements.map(item => ({
        ...item,
        elementNumber: elemNumData.data.find(n => n.elementId == item.id)
            ? elemNumData.data.find(n => n.elementId == item.id).num
            : ''
    }));

    reportElements.svgData = reportData.svgData;

    let lastEditor = await processlistService.retrieveLastEditorForProcess(uuid);
    modelInfo.lastEditor = lastEditor.data;

    if (store.state.clientIcon.startsWith('data:image/svg+xml;base64,')) {
        svgToPngBase64(store.state.clientIcon).then(icon => {
            generateReportPDF(icon, reportElements, filename, modelInfo);
        });
    } else {
        generateReportPDF(store.state.clientIcon, reportElements, filename, modelInfo);
    }

    return reportElements;
}
function getLaneId(activity, elements) {
    const lanes = elements.filter(e => e.type === 'bpmn:Lane');
    const lane = lanes.find(l => l != null && l.businessObject != null && l.businessObject.flowNodeRef != null && l.businessObject.flowNodeRef.includes(activity.businessObject));
    return lane ? lane.businessObject.name : null;
}

function generateReportPDF(icon, reportData, filename, modelInfo) {
    reportData.elements.sort((a, b) => a.elementNumber - b.elementNumber)
    const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [40, 100, 30, 40],
        header: () => ({
            margin: [40, 5, 5, 40],
            stack: [
                {
                    columns: [
                        {
                            width: '90%',
                            stack: [
                                { text: 'Prozessmodell ' + filename, style: 'headerText' },
                                {
                                    text: [
                                        { text: 'Erstellt am: ', color: 'black' },
                                        { text: modelInfo.createdDate.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).replace(',', '') + " ", color: 'gray' },
                                        { text: 'von: ', color: 'black' },
                                        { text: modelInfo.initiator + ' ', color: 'gray' },

                                    ],
                                    style: 'subtitleText'
                                },
                                {
                                    text: [{ text: 'Zuletzt geändert am: ', color: 'black' },
                                    { text: modelInfo.lastModifiedDate.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).replace(',', '') + " ", color: 'gray' },
                                    { text: 'von: ', color: 'black' },
                                    { text: modelInfo.lastEditor + ' ', color: 'gray' }
                                    ],
                                    style: 'subtitleText'
                                },
                                {
                                    text: [{ text: 'Freigegeben am: ', color: 'black' },
                                    { text: new Date().toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(',', '') + " ", color: 'gray' },
                                    { text: 'von: ', color: 'black' },
                                    { text: store.state.currentUser.fullName + ' ', color: 'gray' }
                                    ],
                                    style: 'subtitleText'
                                },
                                {
                                    text: [{ text: 'Dokumentennr: ', color: 'black' },
                                    { text: modelInfo.docNr, color: 'gray' }
                                    ],
                                    style: 'subtitleText'
                                },
                                {
                                    text: [{ text: 'Prozessverantwortlich: ', color: 'black' },
                                    { text: modelInfo.initiator, color: 'gray' }
                                    ],
                                    style: 'subtitleText'
                                }
                            ]
                        },
                        {
                            width: '10%',
                            image: icon,
                            fit: [100, 50],
                            alignment: 'right'
                        }
                    ],
                    columnGap: 10
                },
            ]
        }),
        footer: function (currentPage, pageCount) {
            return {
                margin: [40, 0, 40, 0],
                columns: [
                    {
                        text: 'Seite ' + currentPage.toString() + ' von ' + pageCount,
                        alignment: 'left',
                        style: 'subtitleText'
                    },
                    {
                        text: modelInfo.mngmtLink,
                        alignment: 'right',
                        style: 'subtitleText'
                    }
                ]
            };
        },
        content: [
            {
                svg: reportData.svgData,
                width: 800,
                height: 400,
                style: "centering",
            },
            { text: '', pageOrientation: 'landscape', pageBreak: 'before' },
            {
                table: {
                    headerRows: 1,
                    widths: ['10%', '30%', '20%', '20%', '20%'], // Adjust column proportions
                    body: [
                        [{ text: 'Nr.', style: 'tableHeader', alignment: 'center' },
                        { text: 'Tätigkeit', style: 'tableHeader' },
                        { text: 'Beschreibung', style: 'tableHeader' },
                        { text: 'Rolle', style: 'tableHeader' },
                        { text: 'Link', style: 'tableHeader' }],
                        ...reportData.elements.map(item => [
                            { text: item.elementNumber || '', alignment: 'center', noWrap: false },
                            { text: item.text || '', noWrap: false },
                            { text: item.description || '', noWrap: false },
                            { text: item.role || '', noWrap: false },
                            {
                                text: item.mngmtLink || '', noWrap: false
                            }
                        ])
                    ]
                },
                layout: {
                    fillColor: (rowIndex) => (rowIndex % 2 === 0 ? '#dedede' : null)
                },
                defaultStyle: {
                    fontSize: 10,
                    columnGap: 5, // Adds spacing between columns
                    wordWrap: true // Ensures text wraps
                }
            }
        ],
        styles: {
            header: {
                fontSize: 16,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 14,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black',
                fillColor: '#' + store.state.clientColor
            },
            headerText: {
                fontSize: 14, // Adjust font size as needed
                bold: true, // Make the text bold
                color: 'black', // Header text color
                margin: [0, 0, 0, 0] // Adjust margins as needed
            },
            subtitleText: {
                fontSize: 10,
                italics: true,
                color: 'gray'
            },
        },

    };

    pdfMake
        .createPdf(docDefinition)
        .download("Report_" + filename + ".pdf");
}

function svgToPngBase64(svgBase64) {
    return new Promise((resolve, reject) => {
        // Create an image element
        const img = new Image();
        img.src = svgBase64;

        img.onload = function () {
            // Create a canvas to draw the image
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;

            // Draw the image on the canvas
            ctx.drawImage(img, 0, 0);

            // Get the PNG base64 from the canvas
            const pngBase64 = canvas.toDataURL('image/png');
            resolve(pngBase64);
        };

        img.onerror = function (err) {
            reject('Error converting SVG to PNG: ' + err);
        };
    });
}
const readableNames = {
    id: "ID",
    name: "Name",
    trigger: "Prozessauslöser",
    outcome: "Prozessergebnis",
    description: "Beschreibung",
    department: "Zugeordnete Abteilung",
    systems: "Verbundene Systeme",
    frequency: "Frequency",
    workload: "Arbeitsaufwand",
    connectedDepartments: "Schnittstellen zu anderen Abteilungen",
    type: "Prozesstyp",
    connectedModelId: "Verbundenes Prozessmodell",
    involvedRoles: "Beteiligte Rollen",
    createdBy: "Ersteller",
    createdDate: "Erstelldatum",
    risc: "Prozessrisiko",
    digitalDegree: "Digitaler Reifegrad",
    connectedProcesses: "Verbundene Prozesse"
};

export {
    decodeModuleNameByNumber,
    decodeModuleNameByEnum,
    decodeElementByName,
    getChecklistStepDescription,
    decodeQuestionType,
    decodeModuleNameByNumberForEvaluation,
    decodeSurveyState,
    getSurveyStateDescription,
    parseSurveyStateColor,
    decodePermissionName,
    getPermissionDescription,
    decodeCharacteristicFieldToName,
    generateReportStructure
}